import { render, staticRenderFns } from "./OrganismCreateEditConfigTemplate.vue?vue&type=template&id=e0453a4e&scoped=true&"
import script from "./OrganismCreateEditConfigTemplate.vue?vue&type=script&lang=js&"
export * from "./OrganismCreateEditConfigTemplate.vue?vue&type=script&lang=js&"
import style0 from "./OrganismCreateEditConfigTemplate.vue?vue&type=style&index=0&id=e0453a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0453a4e",
  null
  
)

export default component.exports